import { Modal } from "components/common/Modal";
import { UploadedFilesModalContent } from "./UploadedFilesModalContent";
import type { UploadedFilesModalProps } from "./types";

export const UploadedFilesModal = ({
  isOpen,
  onClose,
  files,
}: UploadedFilesModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} size="lg">
    <UploadedFilesModalContent files={files} onClose={onClose} />
  </Modal>
);
